import React from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import { useMutation, useSegment, useSubscription } from 'utils/hooks';

export default function ToggleModal({
  aggregatorId = '',
  isOpen = false,
  data = null,
  carriers = [],
  onClose = () => {},
  onClosed = () => {},
  onRefresh = () => {}
}) {
  const { track } = useSegment();
  const { isByocStore } = useSubscription();

  const id = _get(data, 'id', '');
  const name = _get(data, 'name', '');
  const isByoc = _get(data, 'is_byoc', false);
  const carrierId = _get(data, 'carrier_id', '');
  const isEnabled = _get(data, 'is_enabled', false);

  const { mutate, isProcessing } = useMutation(
    aggregatorId
      ? 'configure.aggregator.carriers_list'
      : 'configure.carriers.root',
    'PUT',
    {
      routeParams: aggregatorId ? { id: aggregatorId } : {},
      errorMessage: err => {
        const msg = _get(err, 'displayMessage.message', '');
        return msg || 'Unable to update carrier at the moment.';
      },
      successMessage: () => {
        const isEnabled = _get(data, 'is_enabled', false);
        return `The carrier has been ${
          isEnabled ? 'disabled' : 'enabled'
        } successfully.`;
      },
      payload: () => {
        const enabledMap = carriers.reduce((acc, carrier) => {
          const id = _get(carrier, 'id');
          const isEnabled = _get(carrier, 'is_enabled');
          if (isEnabled) acc[id] = true;
          return acc;
        }, {});

        if (isEnabled) delete enabledMap[id];
        else enabledMap[id] = true;

        return { enabled_carrier_ids: Object.keys(enabledMap) };
      },
      onValidate: () => (isByoc ? isByocStore : true),
      onSuccess: data => {
        track('Toggled Carrier', {
          carrier_id: _get(data, 'id', ''),
          is_enabled: !_get(data, 'is_enabled', false)
        });
        onClose();
        onRefresh(null, data);
      },
      onError: err => onRefresh(err)
    }
  );

  if (!data) return null;

  return (
    <UiKit.Modal
      isOpen={isOpen}
      onClose={onClose}
      onClosed={onClosed}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header
        title={`${isEnabled ? 'Disable' : 'Enable'} Carrier`}
      />
      <UiKit.Modal.Body>
        <span>
          You are about to {isEnabled ? 'disable' : 'enable'} the carrier.
        </span>
        <span>
          Carrier Name:{' '}
          <b>
            {name} {carrierId && `(${carrierId})`}
          </b>
        </span>
        <span className="mt-4"> This change can be reverted later.</span>
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer
        onConfirm={() => mutate()}
        confirmBtnVariant={isEnabled ? 'destructive' : 'primary'}
        confirmBtnText={isEnabled ? 'Disable' : 'Enable'}
      />
    </UiKit.Modal>
  );
}
